import { useState } from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useMutation } from '@redwoodjs/web';

import { EmailRecipientsInput } from 'src/components/EmailRecipientsInput';
import { showErrorToast, showSuccessToast } from 'src/components/Toasts/toast';
import { RESEND_COMMISSION_STATEMENT } from 'src/graphql/mutations/commissionStatement.mutation';

type SendCommissionStatementModalProps = {
    handleCloseSendModal: () => void;
    statementId: number;
    partnerBillingContactEmail: string;
    refetchStatementHistoryData: () => void;
};

export const SendCommissionStatementModal = ({
    handleCloseSendModal,
    statementId,
    partnerBillingContactEmail,
    refetchStatementHistoryData,
}: SendCommissionStatementModalProps) => {
    const [sendRecipients, setSendRecipients] = useState<Array<string>>(
        partnerBillingContactEmail ? [partnerBillingContactEmail] : []
    );
    const [resendCommissionStatement, { loading }] = useMutation(RESEND_COMMISSION_STATEMENT, {
        variables: { id: statementId, recipients: sendRecipients },
        onCompleted: (data) => {
            if (data?.resendCommissionStatement) {
                showSuccessToast(`Commission Statement sent successfully!`);
                handleCloseSendModal();
                refetchStatementHistoryData();
            }
        },
        onError: () => {
            showErrorToast(`Commission Statement PDF send error.`);
        },
    });

    const handleResendStatement = async () => {
        resendCommissionStatement({ id: statementId });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
        >
            <Typography
                sx={{
                    fontSize: '16px',
                    color: '#667085',
                    marginBottom: '8px',
                }}
            >
                Enter emails to resend statements to:
            </Typography>
            <Box sx={{ marginTop: '16px' }}>
                <EmailRecipientsInput
                    setSendRecipients={setSendRecipients}
                    sendRecipients={sendRecipients}
                />
            </Box>
            <Stack direction="row" justifyContent={'center'} spacing={2} sx={{ mt: 3 }}>
                <Button
                    variant="outlined-black"
                    onClick={handleCloseSendModal}
                    fullWidth
                    sx={{ width: '170px', height: '44px' }}
                >
                    Close
                </Button>

                <LoadingButton
                    variant="main"
                    onClick={handleResendStatement}
                    fullWidth
                    loading={loading}
                    disabled={sendRecipients.length < 1}
                    sx={{ width: '170px', height: '44px' }}
                >
                    Send
                </LoadingButton>
            </Stack>
        </Box>
    );
};
